import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4EBC73",
      d: "M10.005 18.323A8.333 8.333 0 1 0 2.541 13.7c.148.297.198.636.112.957l-.497 1.855a1.083 1.083 0 0 0 1.327 1.326l1.855-.496c.32-.086.66-.037.957.111a8.3 8.3 0 0 0 3.71.87"
    }, null, -1)
  ]))]))
}
export default { render: render }